import { SK_userSession } from '../../data/config';
import { UserSessionType } from '../../store/slices/UserSession/userSession';
import { parseJsonFromLocal } from '../../utils/helperFunction/jsonHandler';
import { request } from '../../utils/request';

/**
 *
 * @returns this should return a new Authentication token if successful
 */
export const getNewAuthToken = () => {
  const refreshToken: string =
    parseJsonFromLocal<UserSessionType>(SK_userSession)?.signedRefreshPayload ||
    '';
  return request({
    method: 'POST',
    url: '/auth/refresh-token',
    formData: {
      refreshToken,
    },
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
};
